/**
 * Tipo da leg usada na ordem
 */
export enum StrategyRequestOrderType{
    StopGain = 'StopGain',
    Input = 'Input',
    StopLoss = 'StopLoss'
}